// Playlist part
export const YOUTUBE_PLAYLIST_EMBED_PART = 'videoseries?list=';
// Options
export const AUTO_PLAY = 'autoplay';
export const CONTROLS = 'controls';
export const AUTO_HIDE = 'autohide';
export const MODEST_BRANDING = 'modestbranding';
export const SHOW_INFO = 'showinfo';
export const LOOP = 'loop';
export const REL = 'rel';
export const FS = 'fs';
// Allow options
export const ENCRYPTED_MEDIA = 'encrypted-media';
export const ACCELEROMETER = 'accelerometer';
export const GYROSCOPE = 'gyroscope';
export const CLIPBOARD_WRITE = 'clipboard-write';
export const POST_MESSAGE_VALUE = '{"event":"command","func":"stopVideo","args":""}';
